import React, { useContext, useEffect, useRef, useState } from 'react'
import MenuHeader from './../MenuHeader'
import { ProductContext } from '../../../../store'
import { Form, FormGroup, Input } from 'reactstrap'
import DetailSkeleton from '../../../Skeleton/DetailSkeleton'
import Select from 'react-select'

const GeneralCategory = ({type}) => {
	const divRef = useRef(null),
		[categoryDropdown, setCategoryDropdown]	= useState([]),
		[pageLoader, setPageLoader]	= useState(true),
		[openSelect, setOpenSelect]	= useState(false),
		[height, setHeight] = useState("100vh"),
		{
			setCategoryId,
			setProductPage,
			setProducts,
			setOriginalProducts,
			setOriginalProductOrder,
			categoryId,
			description,
			setDescription,
			categories,
			setEnableSave,
			setBuried,
			setPinnedItems,
			setHiddenProductIndex,
			setPinnedProductIndex,
			setHidden,
			setPromoted,
			setBuriedProducts,
			setHiddenProducts,
			editCategoryMerchandising,
			channelId,
			setChannelId,
			setProductLoader,
			channels,
			channelLoader
		}	= useContext(ProductContext)

	useEffect(() => {
		const calculateHeight = () => {
			if (divRef.current) {
				const topPosition = divRef.current.getBoundingClientRect().top;
				const newHeight = `calc(100vh - ${topPosition}px)`;
				setHeight(newHeight);
			}
		};
		calculateHeight();
		window.addEventListener("resize", calculateHeight);
		return () => {
			window.removeEventListener("resize", calculateHeight);
		};
	}, [divRef]);

	useEffect(() => {
		const collectionDropdownLocal = categories.map((currentCollection) => ({
			value: String(currentCollection.collectionId),
			label: `${currentCollection.collectionName} - ${currentCollection.collectionUrl}`,
		}));
		setCategoryDropdown(collectionDropdownLocal);
		setPageLoader(false);
	}, [categories]);

	const updateCollectionId = (newCollectionId) => {
		if (!newCollectionId || !categoryDropdown.some((option) => option.value === newCollectionId)) {
			console.warn("Invalid categoryId provided:", newCollectionId);
			return;
		}
		setEnableSave(false);
		setProducts([]); // Clear existing products
		setProductPage(1);
		setProductLoader(true);
		setBuried([]);
		setHidden([]);
		setPromoted([]);
		setBuriedProducts([]);
		setHiddenProducts([]);
		setCategoryId(newCollectionId);
		setOpenSelect(false);
	}

	return (
		<React.Fragment>
			<MenuHeader title={"General"} />
			<div className='sideBarMenuGridContainer' ref={divRef} style={{height: height, position: "relative"}}>
				<div className='menuContentWrapper'>
					<div className="d-flex flex-column p-4">
						{(pageLoader || channelLoader) ?
							<DetailSkeleton />
						:
							<Form onSubmit={(e) => e.preventDefault()}>
								<FormGroup style={{marginBottom:"20px"}}>
									<div className={`${openSelect ? "categorySelectable" : ""}`}>
										{type === "new" ?
											<>
												<label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>
													Collection (Required)
												</label>
												<Select
													isSearchable={true}
													placeholder="Select Collection"
													maxMenuHeight={300}
													isRequired={true}
													menuPosition="fixed"
													menuPlacement="bottom"
													value={categoryId ? 
														categoryDropdown.find(option => option.value === categoryId) : null
													}
													options={categoryDropdown}
													onChange={(selectedOption) => updateCollectionId(selectedOption?.value)}
													onMenuOpen={() => setOpenSelect(true)}
													onMenuClose={() => setOpenSelect(false)}
												/>
											</>
										:
											<>
												<h4 className='mb-2 font-bold'>Categories</h4>
												<h6>{editCategoryMerchandising?.collectionName}</h6>
											</>
											
										}
									</div>
								</FormGroup>
								<FormGroup style={{marginBottom: "20px"}}>
									<Input
										type="textarea"
										label="Description"
										onChange={(e) => setDescription(e.target.value)}
										placeholder="Description"
										resize={"true"}
										rows={3}
										value={description}
									/>
								</FormGroup>
							</Form>
						}
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}
export default GeneralCategory